import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["checkbox", "input"]
  
  connect() {
    this.toggle()
  }
  
  toggle() {
    if (this.checkboxTarget.checked) {
      this.inputTarget.disabled = false
    } else {
      this.inputTarget.disabled = true
      this.inputTarget.value = ""
      this.inputTarget.setCustomValidity("")
    }
  }
  
  validateUrl() {
    const value = this.inputTarget.value.trim()
    const regex = /^https:\/\/max\.ru\/u\/[A-Za-z0-9_-]+$/
    
    if (value === "") {
      this.inputTarget.setCustomValidity("")
      return
    }
    
    if (!regex.test(value)) {
      this.inputTarget.setCustomValidity(
        "Link must start with https://max.ru/u/"
      )
    } else {
      this.inputTarget.setCustomValidity("")
    }
    
    this.inputTarget.reportValidity()
  }
}
